export enum ProductFamily {
  API_PORTAL = "API Portal",
  API_PRODUCT = "API Product",
  EVENT_PRODUCT = "Event Product",
}
